export enum TagSize {
    DEFAULT = 'default',
    SM = 'sm',
}
